import { Injectable } from '@angular/core';
import {NGXLogger, NgxLoggerLevel} from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { LoggingInfo } from '../models/logging-info.model';
import { StorageService } from './storage.service';


export interface ILoggingMessageService {
  debug(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string);
  info(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string);
  warn(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string);
  error(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string,  message: string, ex: string);
}

@Injectable({
  providedIn: 'root'
})
export class LoggingMessageService implements ILoggingMessageService {
  private env: string;
  private appName: string;
  private userEmail: string;
  private userID: number;
  private authUserID: number;
  public subscriptionID: number;
  public availableSubscriptions: string;

  get UserEmail(): string {
    if (!this.userEmail) {
      this.userEmail = sessionStorage.getItem(environment.TokenEmail);
    }
    return this.userEmail;
  }

  constructor(private sessionService: StorageService, private logger: NGXLogger) {
    this.logger.setCustomHttpHeaders(new HttpHeaders({ Accept: environment.LogMedia,  'Content-Type': 'application/json' }));

    this.env = environment.environment;
    this.appName = `${environment.applicationName} ${environment.applicationVersion}`;
    this.subscriptionID = this.sessionService.getSubscription();
    this.availableSubscriptions = this.sessionService.getSubscriptionsAvailable();
  }

  public debug(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    if ((environment.LogLevel === NgxLoggerLevel.DEBUG) ) {
      const hospid = this.getHospId();
      const unitid = this.getUnitId();
      const indid = this.getIndicatorId();

      setTimeout(() => {
          this.debugMessage(appFileName, appMethod, hospid, unitid, indid, subscriptionID, availableSubscriptions, message, ex);
      }, 0);
    }
  }

  public info(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    if ((environment.LogLevel === NgxLoggerLevel.DEBUG) || (environment.LogLevel === NgxLoggerLevel.INFO)) {
      const hospid = this.getHospId();
      const unitid = this.getUnitId();
      const indid = this.getIndicatorId();

      setTimeout(() => {
          this.infoMessage(appFileName, appMethod, hospid, unitid, indid, subscriptionID, availableSubscriptions, message, ex);
      }, 0);
    }
  }

  public warn(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    if ((environment.LogLevel === NgxLoggerLevel.DEBUG) || (environment.LogLevel === NgxLoggerLevel.INFO) || (environment.LogLevel === NgxLoggerLevel.WARN)) {
      const hospid = this.getHospId();
      const unitid = this.getUnitId();
      const indid = this.getIndicatorId();

      setTimeout(() => {
          this.warnMessage(appFileName, appMethod, hospid, unitid, indid,subscriptionID, availableSubscriptions,  message, ex);
      }, 0);
    }
  }

  public error(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    if ((environment.LogLevel === NgxLoggerLevel.DEBUG) || (environment.LogLevel === NgxLoggerLevel.INFO) || (environment.LogLevel === NgxLoggerLevel.WARN) || (environment.LogLevel === NgxLoggerLevel.ERROR)) {
      const hospid = this.getHospId();
      const unitid = this.getUnitId();
      const indid = this.getIndicatorId();

      setTimeout(() => {
          this.errorMessage(appFileName, appMethod, hospid, unitid, indid,subscriptionID, availableSubscriptions,  message, ex);
      }, 0);
    }
  }

  private isNumber(n: any) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  private getHospId(): number {
    const hosp = this.sessionService.getUserHospitalId();
    const isValid = this.isNumber(hosp);
    return (isValid === true) ? Number(hosp) : 0;
  }

  private getUnitId(): number {
    const unit = this.sessionService.getUnitId();
    const isValid = this.isNumber(unit);
    return (isValid === true) ? Number(unit) : 0;
  }

  private getIndicatorId(): number {
    const ind = this.sessionService.getIndicatorId();
    const isValid = this.isNumber(ind);
    return (isValid === true) ? Number(ind) : 0;
  }

  // Message Logging
  private debugMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.Webserver, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'debug');
    this.logger.debug(li);
  }

  private infoMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.Webserver, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'info');
    this.logger.info(li);
  }

  private warnMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.Webserver, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'warn');
    this.logger.warn(li);
  }

  private errorMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.Webserver, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'error');
    this.logger.error(li);
  }

}
